import { render, staticRenderFns } from "./requestDetail.vue?vue&type=template&id=c0246348&"
import script from "./requestDetail.vue?vue&type=script&lang=js&"
export * from "./requestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports